import React from "react";
import { Grid, IconButton } from "@mui/material";
import NumberEditor from "../inputs/numberEditor";
import RemoveIcon from "@mui/icons-material/RemoveCircleOutline";
import { GetLineItemPrecision } from "../../sharedCode/HelperMethods";
import { rowMargin, TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { TicketLineItem } from "../../sharedCode/avroGraphql";
import LandingLocationEditor from "../inputs/landingLocationEditor";

interface Props extends TicketProps {
    lineItem: TicketLineItem;
    handleDelete: (lineItemToDelete: TicketLineItem) => void;
    mergeRowChanges: (lineItemId: number, changes: Record<string, unknown>) => void;
}

export default function LandingRow(props: Props): JSX.Element {
    const col1width = 9.0;
    const col2width = 2.0;
    const col3width = 1.0;

    return (
        <Grid container flexDirection={"row"} justifyContent={"center"} alignItems={"center"} columnSpacing={1} sx={{ marginTop: rowMargin }}>
            <Grid key={props.lineItem.id} container flexDirection={"row"} spacing={1}>
                <Grid xs={col1width} flex={1} item>
                    <LandingLocationEditor
                        sourceId={props.lineItem.id}
                        sourceProperty="comments"
                        labelText="AIRPORT NAME AND CODE"
                        isRequired={true}
                        initialValue={props.lineItem.comments}
                        mergeChanges={props.mergeRowChanges}
                        isDisabled={props.isReadOnly}
                        errors={props.errors}
                        containerUrl={"ticket/landings"}
                    />
                </Grid>
                <Grid xs={col2width} flex={1} item>
                    <NumberEditor
                        sourceId={props.lineItem.id}
                        sourceProperty="quantity"
                        labelText="COUNT"
                        isRequired={true}
                        initialValue={props.lineItem.quantity}
                        mergeChanges={props.mergeRowChanges}
                        isDisabled={props.isReadOnly}
                        errors={props.errors}
                        containerUrl={"ticket/landings"}
                        precision={GetLineItemPrecision(props.lineItem.line_item_type_id)}
                    />
                </Grid>
                <Grid xs={col3width} item>
                    <IconButton
                        disabled={props.isReadOnly}
                        size="large"
                        edge="start"
                        sx={{ m: 2 }}
                        onClick={() => {
                            props.handleDelete(props.lineItem);
                        }}>
                        <RemoveIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    );
}
